import { h } from "preact";
import { renderPreact } from "../lib/render-preact";
import RestaurantSelection from "./RestaurantSelection";
import { useContext, useMemo } from "preact/hooks";
import { RestaumaticClient, LocalStorage, } from "restaumatic-client";
import PageContext from "./PageContext";
import * as QrWaiter from "../services/QrWaiter";
export default renderPreact("RestaurantSelection", (props) => {
    const settings = useContext(PageContext);
    // NOTICE For SSR purposes we need to create whole new RestaumaticClient instance
    const restaurantSelection = useMemo(() => {
        const client = RestaumaticClient.create({
            config: {
                siteId: settings.siteId,
                locale: settings.locale,
                fallbackLocale: settings.defaultLocale,
                country: settings.country,
                currency: settings.currency,
                // NOTICE Not used in this context, but present due to structural reasons
                isApplePaySupported: false,
                isIosReviewMode: false,
                mobileAppType: null,
            },
            rpcUrl: "",
            storage: LocalStorage.create(),
            qrWaiter: QrWaiter,
        });
        return client.createRestaurantSelection(props.initialRestaurants);
    }, [settings, props.initialRestaurants]);
    return (h(RestaurantSelection, { ...props, restaurantSelection: restaurantSelection, navigationType: "anchor" }));
});
